// extracted by mini-css-extract-plugin
export var heart = "InviteYourFriendsBannerDesktop-module__heart___v_0iW";
export var banner = "InviteYourFriendsBannerDesktop-module__banner___fGz1A";
export var invite = "InviteYourFriendsBannerDesktop-module__invite___lMq8d";
export var content = "InviteYourFriendsBannerDesktop-module__content___xdRmX";
export var picture = "InviteYourFriendsBannerDesktop-module__picture___IWfwP";
export var img = "InviteYourFriendsBannerDesktop-module__img___Fv4cp";
export var icon = "InviteYourFriendsBannerDesktop-module__icon___x4F86";